// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var LeftPane$ReactHooksTemplate = require("./components/LeftPane.res.js");
var Timeline$ReactHooksTemplate = require("./components/Timeline.res.js");
var DetailPane$ReactHooksTemplate = require("./components/DetailPane.res.js");
var TimelineEvent$ReactHooksTemplate = require("./components/TimelineEvent.res.js");

function Customer360(props) {
  var match = React.useState(function (param) {
        return [];
      });
  var setJourneyData = match[1];
  var profile_tags = [
    "Platinum",
    "Influencer"
  ];
  var profile = {
    name: "Samantha Smith -Jones",
    email: "ssmith@gmail.com",
    phone: "5407531122",
    location: "London, UK",
    healthScore: "Good Standing",
    tags: profile_tags,
    customerSince: "July 4, 2013",
    birthday: "May 24, 1987",
    address: "221B Baker St, London"
  };
  React.useEffect((function (param) {
          Js_promise.then_((function (json) {
                  var decodedData = Json_decode.field("journey_data", (function (param) {
                          return Json_decode.list(TimelineEvent$ReactHooksTemplate.decodeEvent, param);
                        }), json);
                  Curry._1(setJourneyData, (function (param) {
                          return Belt_List.toArray(decodedData);
                        }));
                  return Promise.resolve();
                }), Http$ReactHooksTemplate.fetchGetJSON("/api/v1/customer_journeys"));
        }), []);
  var match$1 = React.useState(function (param) {
        
      });
  var setActiveChannel = match$1[1];
  var match$2 = React.useState(function (param) {
        
      });
  var setSelectedEvent = match$2[1];
  var selectedEvent = match$2[0];
  var match$3 = React.useState(function (param) {
        return "";
      });
  var setSearchFilter = match$3[1];
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx(LeftPane$ReactHooksTemplate.make, {
                            profile: profile
                          }),
                      JsxRuntime.jsx(Timeline$ReactHooksTemplate.make, {
                            events: match[0],
                            activeChannel: match$1[0],
                            searchFilter: match$3[0],
                            setSearchFilter: (function (search) {
                                Curry._1(setSearchFilter, (function (param) {
                                        return search;
                                      }));
                              }),
                            onChannelSelect: (function (channel) {
                                Curry._1(setActiveChannel, (function (param) {
                                        return channel;
                                      }));
                              }),
                            onEventSelect: (function ($$event) {
                                Curry._1(setSelectedEvent, (function (param) {
                                        return $$event;
                                      }));
                              }),
                            selectedEvent: selectedEvent
                          }),
                      JsxRuntime.jsx(DetailPane$ReactHooksTemplate.make, {
                            selectedEvent: selectedEvent,
                            analytics: {
                              totalOrders: 12,
                              avgResolutionTime: 3.2,
                              lastContactedChannel: "Freshchat",
                              lifetimeValue: 3140.0
                            }
                          })
                    ],
                    className: "flex h-screen"
                  }),
              className: "bg-gray-100 h-screen overflow-hidden"
            });
}

var make = Customer360;

exports.make = make;
/* react Not a pure module */
